import joi from 'joi';
import { EventName, EventSource } from '@loyalty/shared-common';

export interface IncomingEventProcessingWebhookAttributes {
  id: string;
  accountId: string;
  programId: string;
  config?: IncomingWebhookConfig | null;
}

export interface AddIncomingWebhookBody {
  config?: IncomingWebhookConfig | null;
  accountId: string;
}

export interface UpdateIncomingWebhookBody {
  config?: IncomingWebhookConfig | null;
}

const $incomingWebhookConfig = joi
  .object<IncomingWebhookConfig>({
    integrationId: joi.string().empty('').optional(),
    interactionId: joi.string().empty('').optional(),
    interactionJsonata: joi.string().empty('').optional(),
  })
  .unknown(true);

export const $addIncomingWebhookBody = joi.object<AddIncomingWebhookBody>({
  config: $incomingWebhookConfig.optional().allow(null),
  accountId: joi.string(),
});

export const $updateIncomingWebhookBody = joi.object<UpdateIncomingWebhookBody>({
  config: $incomingWebhookConfig.optional().allow(null),
});

export interface IncomingWebhookMappedEventConfig {
  mapTo: {
    source: EventSource;
    name: EventName;
  };
  jsonata: string;
  integrationId?: string;
  interactionId?: string;
  interactionJsonata?: string;
}

export type IncomingWebhookConfig = IncomingWebhookMappedEventConfig;
